/**
 * Function that compose multiple providers in an Array
 * providers are composed top to bottom (or left to right)
 */
export default (providers) => {
  return ({ children }) => {
    return providers.reduceRight((tree, ProviderWithProps, index) => {
      if (Array.isArray(ProviderWithProps)) {
        const [Provider, value] = ProviderWithProps;
        return (
          <Provider key={index} {...value}>
            {tree}
          </Provider>
        );
      }
      return <ProviderWithProps key={index}>{tree}</ProviderWithProps>;
    }, children);
  };
};
